export default "__VITE_ASSET__DyPLv6py__"